import React, {useEffect, useState} from 'react';
import {EmployeeLayout} from '../EmployeeLayout/EmployeeLayout';
import style from './Submissions.module.css';
import '../../../index.css'
import CompanyIcon from './../../../assets/icons/Company2.svg';
import {authAxios} from "../../../API/apiRequest";
import {Button} from "../../../components/Button/Button";
import {useMediaQuery} from "@material-ui/core";
import {FiClock} from "react-icons/fi";
import styled from "styled-components";
import {Loading} from "../../../components/Loading/Loading";
import TimeAgo from "javascript-time-ago";
import {ModalSubmit} from './ModalSubmit';
import {NoData} from '../../../components/NoData/NoData';

const TimeAndViews = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-right: 5px;
  padding-top: 5px;
`
const Time = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const TimeText = styled.p`
  font-size: 11px;
  color: #BBBBBB;
  padding: 0;
  margin: 0;
  margin-left: 5px;
`
const Submissions: any = () => {
    const timeAgo = new TimeAgo('ar-EG')
    const [Load, setLoad] = useState<boolean>(true);
    const [noData, setnoData] = useState<boolean>(false);
    const matches = useMediaQuery('(max-width:510px)');
    const [Jop, setJop]: any = useState<{
                appointment: string,
                createdAt: string,
                companyId: string,
                companyImage: string,
                companyName: string,
                form: Array<{
                    question: string, answer: string
                }>,
                id: string,
                jobId: string,
                jobName: string,
                status: string,
                updatedAt: string,
            }>(),
            [Open, setOpen] = useState(false),
            [ModalLoad, setModalLoad] = useState<boolean>(true);
    const HandleOpenModal: any = (data: any) => {
        setOpen(true);
        setModalLoad(true);
        authAxios.get(`/employee/applications/${data}`).then((res) => {
            if(res.status === 200) {
                setModalLoad(false);
                setJop(res.data.application);
                setLoad(false);
            }
        }).catch(err => {
            console.log(err)
        })
    }
    const [page, setpage] = useState(1);
    const [ApplicationsData, setApplicationsData] = useState<{
        applications: Array<{
            createdAt: string,
            companyId: string,
            id: string,
            companyPicture: string,
            companyName: string,
            status: string,
            title: string,
            updatedAt: string,
        }>
        hasNext: boolean,
        lastPage: number,
        nextPage: number,
        total: number,
    }>();
    useEffect(() => {
        setLoad(true);
        authAxios.get(`/employee/applications?page=${page}`).then((res) => {
            if(res.status === 200 && res.data.applications.length !== 0) {
                setApplicationsData(res.data)
            } else if(res.data.applications.length === 0) {
                setnoData(true)
            }
            setLoad(false);
        }).catch(err => {
            console.log(err)
        })
    }, [page])
    return (<>

        <EmployeeLayout>
            {!Load && !noData && ApplicationsData && ApplicationsData.applications.length > 0 ? (
                    <div className={'mxheight100  pb25px animate__animated animate__fadeIn'}>
                        <div className='container rtl' style={{boxSizing: 'border-box'}}>
                            <h2 className={' text-white'}>طلبات التقديم</h2>
                            <div className='d-flex  flex-wrap justify-content-center contain '>


                                {
                                    ApplicationsData.applications.map(job => {
                                        return (
                                                <div onClick={() => HandleOpenModal(job.id)} key={job.id}>
                                                    <div className={'p-2 ' + style.card}>
                                <span className={style.StateFlag}

                                      style={{
                                          background: job.status === "SENT" ? '#395F74' :
                                                  job.status === "ACCEPT" ? '#29793A' : job.status === "SEEN" ? '#9E7E0B' : job.status === "REJECT" ? '#922424' : ""
                                      }}
                                      title={job.status === "SENT" ? 'تم الإرسال' :
                                              job.status === "ACCEPT" ? 'تم تحديد موعد المقابلة' : job.status === "SEEN" ? 'تم رؤية الطلب' : job.status === "REJECT" ? 'مرفوض' : ""}>
                                    <p className={style.StateText}>{job.status === "SENT" ? 'تم الإرسال' :
                                            job.status === "ACCEPT" ? 'موعد مقابلة' : job.status === "SEEN" ? 'تم رؤية الطلب' : job.status === "REJECT" ? 'مرفوض' : ""}</p></span>
                                                        <div>
                                                            <img
                                                                    className={style.ImgCompanyLogo + ` ${job.companyPicture ? (style.ObjectFitFill) : (style.ObjectFitNone)}`}
                                                                    height={'100px'} width={'100px'}
                                                                    alt={job.companyName}
                                                                    src={job.companyPicture ? job.companyPicture : CompanyIcon}/>
                                                        </div>
                                                        <div className='d-flex flex-column mx-2 '>

                                                            <p className={style.joptitle}>{job.title}</p>
                                                            <p className={style.companyname + " p-0 m-0"}>{job.companyName}</p>
                                                            <TimeAndViews>
                                                                <Time>
                                                                    <FiClock color='#BBBBBB' size={19}
                                                                             style={{marginLeft: 8}}/>
                                                                    <TimeText>منذ {(timeAgo.format(Date.now() - (Date.now() - new Date(job.createdAt).getTime()))).toString().replace("قبل", '')}</TimeText>
                                                                </Time>
                                                            </TimeAndViews>
                                                        </div>
                                                    </div>

                                                </div>
                                        )
                                    })
                                }
                            </div>
                            {!ApplicationsData.hasNext && page === 1 ? "" : (
                                    <div className={"d-flex  align-items-center justify-content-center"}>
                                        <div className={"my-2 " + style.pages}>
                                            <Button width={matches ? 150 : undefined} height={matches ? 38 : undefined}
                                                    disabled={!(ApplicationsData && ApplicationsData.hasNext)}
                                                    onPress={() => {
                                                        if(ApplicationsData && ApplicationsData.hasNext) {
                                                            let num = page;
                                                            num++;
                                                            setpage(num);
                                                        }
                                                    }}
                                                    color='black'>التالي</Button>

                                            <Button width={matches ? 150 : undefined} height={matches ? 38 : undefined}


                                                    disabled={page <= 1}
                                                    onPress={() => {
                                                        if(page > 1) {
                                                            let num = page;
                                                            num--;
                                                            setpage(num);
                                                        }
                                                    }}
                                                    color='black'>السابق</Button>

                                        </div>
                                    </div>
                            )}
                        </div>
                    </div>
            ) : !noData ? (<Loading/>) : (<NoData/>)}

        </EmployeeLayout>


        <ModalSubmit Open={Open} ModalLoad={ModalLoad} setOpen={setOpen} Jop={Jop}/>

    </>)
}
export default Submissions;